import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '@res/ng-repository';
import { RentFirestoreService } from '../../services/rent.firestore.service';
import { RentActions } from './rent.action';
import { RentStateModel } from './rent.store';
import { TypesaurusCore } from 'typesaurus';
import { GridApi } from 'ag-grid-community';

@State<RentStateModel>({
  name: 'rents',
  defaults: {
    rents: [],
    doneRents: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
    off: new Map<string, TypesaurusCore.OffSubscriptionWithCatch>(),
  },
})
@Injectable()
export class RentState {
  private rentService = inject(RentFirestoreService);
  private readonly grids: Map<string, GridApi> = new Map<string, GridApi>();
  // private userState = inject(RentState);
  // private dbUser = inject(OrmService).rentCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(RentActions.AddGrid)
  addGrid(ctx: StateContext<RentStateModel>, { api, uGridName }: RentActions.AddGrid) {
    this.grids.set(uGridName, api);
  }

  @Action(RentActions.OnGetAllQueryRent)
  onGetAllQueryRents(ctx: StateContext<RentStateModel>, { request, stateSelectorName }: RentActions.OnGetAllQueryRent) {
    const offCtx = ctx.getState().off;
    const stringifiedRequest = JSON.stringify(request);
    if (!offCtx.has(stringifiedRequest)) {
      ctx.patchState({ isLoading: true });
      const off = this.rentService.OnQueryAll(request, (data) =>
        ctx.dispatch(new RentActions.UpdateRentResult(data, stateSelectorName)),
      );
      offCtx.set(stringifiedRequest, off);
      ctx.patchState({ off: offCtx });
    }
  }

  onGetAllRents(ctx: StateContext<RentStateModel>, { stateSelectorName }: RentActions.OnGetAllQueryRent) {
    const offCtx = ctx.getState().off;
    if (!offCtx.has(stateSelectorName)) {
      ctx.patchState({ isLoading: true });
      const off = this.rentService.OnGetAll((data) =>
        ctx.dispatch(new RentActions.UpdateRentResult(data, stateSelectorName)),
      );

      //   (datas) => {
      //   ctx.patchState({
      //     [stateSelectorName]: datas.filter((x) => Boolean(x)).map(({ data, ref }) => ({ ...data, ref })),
      //     isLoading: false,
      //   });
      // });
      offCtx.set(stateSelectorName, off);
      ctx.patchState({ off: offCtx });
    }
  }

  @Action(RentActions.GetAllRent)
  async getAllRents(ctx: StateContext<RentStateModel>, { stateSelectorName }: RentActions.GetAllRent) {
    ctx.patchState({ isLoading: true });
    const rents = await this.rentService.GetAll();
    ctx.patchState({
      [stateSelectorName]: rents.filter((x) => Boolean(x)).map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(RentActions.UpdateRent)
  async updateRents(ctx: StateContext<RentStateModel>, { rentData, ref }: RentActions.UpdateRent) {
    await this.rentService.Update(ref, rentData);
  }

  @Action(RentActions.UpdateRentResult)
  updateRentResult(ctx: StateContext<RentStateModel>, { data, stateSelectoreName }: RentActions.UpdateRentResult) {
    patchState<RentStateModel>(ctx, stateSelectoreName, data);
    // [...this.grids.values()].map(x=>x.applyTransactionAsync({update:data}))
  }

  @Action(RentActions.PaginateQueryRent)
  async queryRents(
    ctx: StateContext<RentStateModel>,
    { request, isResetAfterFilterOrSort }: RentActions.PaginateQueryRent,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['userId']) {
    //   (request.filterModel as FilterModel)['userId']['values'] = (request.filterModel as FilterModel)[
    //     'userId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(RentState.users).find((user) => user.companyName === v)?.ref
    //   );
    // }
    // if (userId) {
    //   request.filterModel = {
    //     userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.rentService.SetQuery({
      ...request,
      count: state.rents.length,
      data: state.rents,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.rents.length;
      state.rents = [];
      state.rents.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.rents = [];
      state.rents.length = await this.rentService.GetBuildedCount(runs);
    }
    if (state.rents.length !== 0) {
      runs.push(...this.rentService.SetLimit({ ...request, count: state.rents.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const rentss = await this.rentService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        rentss.reverse().forEach(
          ({ data, ref }, i) =>
            (state.rents[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        rentss.forEach(
          ({ data, ref }, i) =>
            (state.rents[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, rents: state.rents });
  }

  @Action(RentActions.OnQueryRent)
  async onQueryRents(
    ctx: StateContext<RentStateModel>,
    { request, stateSelectorName, isResetAfterFilterOrSort }: RentActions.OnQueryRent,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['userId']) {
    //   (request.filterModel as FilterModel)['userId']['values'] = (request.filterModel as FilterModel)[
    //     'userId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(RentState.users).find((user) => user.companyName === v)?.ref
    //   );
    // }
    // if (userId) {
    //   request.filterModel = {
    //     userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.rentService.SetQuery({
      ...request,
      count: state[stateSelectorName].length,
      data: state[stateSelectorName],
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.rents.length;
      state[stateSelectorName] = [];
      state[stateSelectorName].length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state[stateSelectorName] = [];
      state[stateSelectorName].length = await this.rentService.GetBuildedCount(runs);
    }
    if (state[stateSelectorName].length !== 0) {
      runs.push(...this.rentService.SetLimit({ ...request, count: state.rents.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const rentss = await this.rentService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        rentss.reverse().forEach(
          ({ data, ref }, i) =>
            (state[stateSelectorName][i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        rentss.forEach(
          ({ data, ref }, i) =>
            (state[stateSelectorName][i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, [stateSelectorName]: state[stateSelectorName] });
  }
  // @Action(RentActions.RentError)
  // async rentsError(ctx: StateContext<RentStateModel>, { error }: RentActions.RentError) {
  //   console.error({ error });
  //   // await this.rentService.Update(id, rentsData);
  // }

  /**
   * `ref.set` wrote the document raw, and raw is the problem: `createdAt` is added by
   * `AbstractGenFirestoreService.Create`/`Set`, not by Firestore. Once the wizard started
   * preallocating a reference, every save took that raw branch and `toRentDocument` supplies no
   * timestamp either, so saved rentals had no `createdAt` at all: the Events grid's Time column
   * was blank and any date sort or filter mishandled them.
   *
   * The first write goes through `Set`, which stamps a server `createdAt`; later writes go through
   * `Update`, which stamps `updatedAt` and leaves the creation time alone.
   */
  @Action(RentActions.SaveRent)
  saveRent(ctx: StateContext<RentStateModel>, { rentData, ref, isInitialWrite }: RentActions.SaveRent) {
    if (!ref) {
      return this.rentService.Create(rentData);
    }
    return isInitialWrite ? this.rentService.Set(ref, rentData) : this.rentService.Update(ref, rentData);
  }

  @Action(RentActions.DeleteRents)
  async deletetRents(ctx: StateContext<RentStateModel>, { refs }: RentActions.DeleteRents) {
    await this.rentService.BatchDelete(refs);
  }

  // @Action(RentActions.GetSumsCountOf)
  // public async getCountOf(
  //   ctx: StateContext<RentStateModel>,
  //   { fields, timePeriod, filterModel, userId }: RentActions.GetSumsCountOf
  // ) {
  //   const query = {
  //     filterModel: {},
  //     startRow: undefined,
  //     endRow: undefined,
  //     sortModel: [],
  //     data: [],
  //     count: 0,
  //   };
  //   if (timePeriod.dateFrom && timePeriod.dateTo) {
  //     (query.filterModel as any)['createdAt'] = {
  //       colId: 'createdAt',
  //       type: 'inRange',
  //       filter: timePeriod.dateFrom,
  //       filterTo: timePeriod.dateTo,
  //     };
  //   }
  //   // if (userId) {
  //   //   filterModel = { userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' }, ...filterModel };
  //   // }
  //   for (const fieldKey in filterModel) {
  //     (query.filterModel as any)[fieldKey] = (filterModel as any)[fieldKey];
  //   }
  //   (query.filterModel as any)['paymentResult'] = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };

  //   // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
  //   const extraQuerry = this.rentService.SetQuery(query);
  //   const querrys: { [key: string]: { sum: number; count: number } } = {};
  //   for (const field of fields) {
  //     querrys[field.sumId] = {
  //       sum: await this.rentService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
  //       count: await this.rentService.QueryCountByCreationDate(field.countId, field.countValue, extraQuerry.runs),
  //     };
  //   }
  //   ctx.patchState({ sums: querrys });
  // }

  @Selector()
  static rents(state: RentStateModel) {
    return state.rents;
  }
  @Selector()
  static doneRents(state: RentStateModel) {
    return state.doneRents;
  }
  // @Selector()
  // static rentsCount(state: RentStateModel) {
  //   return state.rents.length;
  // }

  @Selector()
  static sums(state: RentStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: RentStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static rentState(state: RentStateModel) {
    return state;
  }

  @Selector()
  static rentFilter(state: RentStateModel) {
    return state.filter;
  }
}
